import baseApiWithReauth from 'infrastructure/redux/adapters/mboAPI/baseApiWithReauth';

// Regional booking event types
export enum RegionalBookingEventType {
  ALTERNATIVES_SHOWN = 'regional_alternatives_shown',
  ALTERNATIVE_CLICKED = 'regional_alternative_clicked',
  ALTERNATIVE_BOOKED = 'regional_alternative_booked',
  ALTERNATIVES_REJECTED = 'regional_alternatives_rejected',
  PARTIAL_DURATION_ACCEPTED = 'regional_partial_duration_accepted',
  ORIGINAL_BOOKED = 'regional_original_booked',
}

export interface TrackRegionalBookingEventParams {
  eventType: RegionalBookingEventType;
  locationGroupId?: string;
  originalLocationId?: string;
  alternativeLocationId?: string;
  metadata?: Record<string, unknown>;
}

const adminAPI = baseApiWithReauth
  .enhanceEndpoints({
    addTagTypes: ['UserActions', 'RegionalBookingAnalytics'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // Analytics user action endpoints
      submitAnalyticsAction: builder.mutation<
        void,
        { actionType: string; metadata?: Record<string, unknown> }
      >({
        query: (body) => ({
          url: 'analytics/user-action',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['UserActions'],
      }),
      hasUserPerformedAction: builder.query<{ hasPerformed: boolean }, string>({
        query: (actionType) => `analytics/user-action/has-performed?actionType=${actionType}`,
        providesTags: ['UserActions'],
      }),

      // Regional booking analytics tracking
      trackRegionalBookingEvent: builder.mutation<
        { success: boolean; eventId: string },
        TrackRegionalBookingEventParams
      >({
        query: (body) => ({
          url: 'regional-booking/analytics/track',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['RegionalBookingAnalytics'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useSubmitAnalyticsActionMutation,
  useHasUserPerformedActionQuery,
  useTrackRegionalBookingEventMutation,
} = adminAPI;

export default adminAPI;
